import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Heart, Menu, X } from "lucide-react";
import { useState } from "react";
import A11yToggle from "@/components/A11yToggle";

const linkCls = "text-slate-700 hover:text-[#D96B43] font-medium transition-colors min-h-[48px] flex items-center px-1";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-40 bg-[#FAF8F5]/95 backdrop-blur-md border-b border-[#E2D9CE]">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="w-10 h-10 rounded-xl bg-[#D96B43] flex items-center justify-center shadow-sm">
            <Heart className="w-5 h-5 text-white" fill="white" />
          </span>
          <span className="text-2xl font-display font-bold text-slate-900">Kindred</span>
        </Link>

        <nav className="hidden md:flex items-center gap-6">
          <Link to="/browse" data-testid="nav-browse" className={linkCls}>Find Help</Link>
          <Link to="/helpers" data-testid="nav-helpers" className={linkCls}>Our Helpers</Link>
          {user && <Link to="/dashboard" data-testid="nav-dashboard" className={linkCls}>Dashboard</Link>}
          {user?.role === "helper" && <Link to="/earnings" data-testid="nav-earnings" className={linkCls}>My earnings</Link>}
          {user && <Link to="/messages" data-testid="nav-messages" className={linkCls}>Messages</Link>}
          {user?.role === "admin" && <Link to="/admin" data-testid="nav-admin" className={linkCls}>Admin</Link>}
          <A11yToggle compact />
          {!user ? (
            <>
              <Link to="/login" data-testid="nav-login-btn" className={linkCls}>Log in</Link>
              <Link to="/register" data-testid="nav-register-btn"
                className="bg-[#D96B43] hover:bg-[#C25832] text-white font-semibold px-5 min-h-[48px] rounded-xl flex items-center transition-colors">
                Join Kindred
              </Link>
            </>
          ) : (
            <div className="flex items-center gap-4">
              <Link to="/profile" data-testid="nav-profile" className="text-slate-700 hover:text-[#D96B43] font-medium">
                Hi, {user.name.split(" ")[0]}
              </Link>
              <button onClick={handleLogout} data-testid="nav-logout-btn"
                className="border-2 border-[#E2D9CE] hover:border-[#D96B43] text-slate-800 font-semibold px-4 min-h-[48px] rounded-xl transition-colors">
                Log out
              </button>
            </div>
          )}
        </nav>

        <div className="md:hidden flex items-center gap-2">
          <A11yToggle compact />
          <button className="p-2" data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)}>
            {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {open && (
        <nav className="md:hidden px-4 pb-4 flex flex-col gap-2 border-t border-[#E2D9CE]" onClick={() => setOpen(false)}>
          <Link to="/browse" className={linkCls}>Find Help</Link>
          <Link to="/helpers" className={linkCls}>Our Helpers</Link>
          {user && <Link to="/dashboard" className={linkCls}>Dashboard</Link>}
          {user?.role === "helper" && <Link to="/earnings" className={linkCls}>My earnings</Link>}
          {user && <Link to="/messages" className={linkCls}>Messages</Link>}
          {user?.role === "admin" && <Link to="/admin" className={linkCls}>Admin</Link>}
          {!user ? (
            <>
              <Link to="/login" className={linkCls}>Log in</Link>
              <Link to="/register" className="text-[#D96B43] font-semibold min-h-[48px] flex items-center">Join Kindred</Link>
            </>
          ) : (
            <>
              <Link to="/profile" className={linkCls}>Profile</Link>
              <button onClick={handleLogout} className="text-left text-slate-700 font-medium min-h-[48px]">Log out</button>
            </>
          )}
        </nav>
      )}
    </header>
  );
}
